import getDoc from '@winman-f2e/rc/lib/definitionGetter'
import genCachablePromiseGetter from '@winman-f2e/rc/lib/genCachablePromiseGetter'

let promiseGetter = () => getDoc('MTU3NDA2MjY1NDE3M18zNQ==')

export default genCachablePromiseGetter(promiseGetter)



// WEBPACK FOOTER //
// ./src/pages/index/config.js